import { getLocaleFromPath, localizePath, stripLocalePrefix } from './localePaths';

const INTERNAL_ORIGIN = 'https://auth-return.invalid';
const AUTH_PATH = /^\/(?:login|register|login-success|social-signup|kakao-channel|forgot-password|reset-password)(?:\/|$)/i;

// Accept router locations as well as OAuth/expired-session query parameters.
// Validate decoded forms too: browsers/proxies can normalize escaped separators.
export function safeAuthReturnPath(value, fallback = '/') {
  let path = typeof value === 'string' ? value : value?.pathname;
  if (typeof path !== 'string') return fallback;
  if (typeof value !== 'string') path += `${value.search || ''}${value.hash || ''}`;

  let decoded = path;
  for (let pass = 0; pass < 8; pass += 1) {
    const hasControl = Array.from(decoded).some(char => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127);
    if (!decoded.startsWith('/') || decoded.startsWith('//') || decoded.includes('\\') || hasControl) return fallback;
    try {
      const url = new URL(decoded, INTERNAL_ORIGIN);
      const logicalPath = stripLocalePrefix(url.pathname.toLowerCase());
      if (url.origin !== INTERNAL_ORIGIN || logicalPath.startsWith('//') || AUTH_PATH.test(logicalPath)) return fallback;
      const next = decodeURIComponent(decoded);
      if (next === decoded) return path;
      decoded = next;
    } catch {
      return fallback;
    }
  }
  return fallback;
}

export function authReturnPathFromLocation(location, fallback = '/') {
  const next = new URLSearchParams(location?.search || '').get('next');
  return safeAuthReturnPath(location?.state?.from ?? next, fallback);
}

export function expiredSessionLoginPath(location) {
  const locale = getLocaleFromPath(location?.pathname || '/');
  const next = safeAuthReturnPath(location, localizePath('/', locale));
  return `${localizePath('/login', locale)}?${new URLSearchParams({ next }).toString()}`;
}
